<div class="sidenav">
  <slot></slot>
</div>
